const SLIDE_DURATION_MS = 4000;

document.addEventListener('DOMContentLoaded', () => {
  const cardImageGroups = document.querySelectorAll('[data-card-image-items]');

  cardImageGroups.forEach((group) => {
    const items = Array.from(group.querySelectorAll('.card__image-item'));
    const navButtons = Array.from(
      group.querySelectorAll('[data-card-image-nav-button]')
    );

    if (items.length <= 1) return;

    let currentIndex = items.findIndex((item) => !item.hasAttribute('hidden'));
    if (currentIndex < 0) currentIndex = 0;

    const showImage = (index) => {
      currentIndex = index;

      items.forEach((item, itemIndex) => {
        item.hidden = itemIndex !== currentIndex;
      });

      navButtons.forEach((button, buttonIndex) => {
        button.setAttribute(
          'aria-current',
          buttonIndex === currentIndex ? 'true' : 'false'
        );
      });
    };

    const showNextImage = () => {
      const nextIndex = (currentIndex + 1) % items.length;
      showImage(nextIndex);
    };

    let intervalId = window.setInterval(showNextImage, SLIDE_DURATION_MS);

    const restartInterval = () => {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(showNextImage, SLIDE_DURATION_MS);
    };

    navButtons.forEach((button, buttonIndex) => {
      button.addEventListener('click', () => {
        showImage(buttonIndex);
        restartInterval();
      });
    });

    showImage(currentIndex);
  });
});
